// extracted by mini-css-extract-plugin
module.exports = {"AppChip":"AppChip_AppChip__33Hc_","appChipContent":"AppChip_appChipContent__1PQQc"};